import { myListsDetailsOptionsStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsOptions";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import PlusCircle from "@insite/mobius/Icons/PlusCircle";
import Search from "@insite/mobius/Icons/Search";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

myListsDetailsOptionsStyles.wrapper = {
    css: css`
        @media print {
            display: none;
        }
        display: flex;
        margin: 0;
    `,
};
myListsDetailsOptionsStyles.container = {
    gap: 10,
    css: css`
        margin-top: 0px;
    `,
};
myListsDetailsOptionsStyles.addItemsLink = {
    color: "primary",
    icon: {
        iconProps: { src: PlusCircle },
    },
    typographyProps: {
        css: css`
            padding-left: 5px;
        `,
    },
};
myListsDetailsOptionsStyles.selectAllGridItem = {
    width: [12, 7, 6, 4, 3],
    css: css`
        align-items: center;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: flex-start;
                `,
                css`
                    justify-content: space-between;
                `,
                null,
                null,
                null,
            ])}
    `,
};
myListsDetailsOptionsStyles.editSortOrder = {
    css: css`
        cursor: pointer;
        margin-left: 30px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin-left: 0px;
                `,
                null,
                null,
                null,
                null,
            ])}
    `,
};
myListsDetailsOptionsStyles.addItemsGridItem = {
    width: [12, 5, 6, 4, 5],
    css: css`
        align-items: center;
    `,
};
myListsDetailsOptionsStyles.search = {
    cssOverrides: {
        inputSelect: css`
            padding: 0 30px 0 10px;
            &:focus {
                padding: 0 30px 0 10px;
            }
        `,
    },
    iconProps: {
        src: Search,
    },
};
myListsDetailsOptionsStyles.uploadItemsLink = {
    css: css`
        margin: 0px;
        border: 2px solid ${getColor("common.accent")};
        border-radius: 0.5em;
        background: transparent;
        padding: 0 15px;
        min-height: 40px;
        font-weight: bold;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                    margin-bottom: 1rem;
                    justify-content: center;
                `,
                css`
                    width: 100%;
                    margin-bottom: 1rem;
                    justify-content: center;
                `,
                css`
                    margin-bottom: 1rem;
                `,
                null,
                null,
            ])}
    `,
};
myListsDetailsOptionsStyles.uploadItemsGridItem = {
    width: [12, 12, 12, 2, 2],
    css: css`
        align-items: center;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                null,
                css`
                    padding-top: 30px;
                `,
                css`
                    padding-top: 30px;
                `,
            ])}
    `,
};
myListsDetailsOptionsStyles.uploadItemsModal = {
    sizeVariant: "large",
    cssOverrides: {
        modalTitle: css`
            padding: 10px 30px;
        `,
        modalContent: css`
            padding: 20px 30px;
        `,
    },
};
myListsDetailsOptionsStyles.orderUploadErrorsModalStyles = {
    errorMessagesModal: {
        cssOverrides: {
            modalContent: css`
                width: 100% !important;
                overflow: auto !important;
            `,
        },
    },
    modal: {
        sizeVariant: "medium",
        cssOverrides: {
            modalTitle: css`
                padding: 10px 20px;
            `,
            modalContent: css`
                padding: 20px;
                width: 100% !important;
                overflow: auto !important;
            `,
        },
    },
};
